import { orderXClient } from '@/service/client'
import { SendStepUpCodeRequest, SendStepUpCodeResponse } from '@/types/generated/common/auth'
import { ServerMessage } from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function sendStepUpCode(payload: SendStepUpCodeRequest) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { sendStepUpCode: payload })
    const sendStepUpCodeResponse = data.sendStepUpCodeResponse as SendStepUpCodeResponse
    if (!sendStepUpCodeResponse?.success) {
      return Promise.reject({
        status: 400,
        message: sendStepUpCodeResponse?.errorMessage || 'Failed to send verification code',
      })
    }
    return sendStepUpCodeResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
